import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { platformShortcut, useRegisterHotkey } from "@repo/common/hotkeys";
import { getPageNamespace } from "@/constants/bidc-page-namespaces";
import { BidcProvider, useBidc } from "./bidc-context";
type Props = {
  children: ReactNode;
  pathname: string;
};
function GlobalSearchHotkey() {
  const $ = _c(4);
  const {
    sendShortcutCommand,
    ns
  } = useBidc();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = platformShortcut("k");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    keys,
    display
  } = t0;
  let t1;
  if ($[1] !== ns || $[2] !== sendShortcutCommand) {
    t1 = {
      id: "focus-global-search",
      keys,
      display,
      description: "Open global search",
      group: "General",
      enableOnEditable: true,
      ignoreRepeat: true,
      handler: async () => {
        const result = await sendShortcutCommand("focus-global-search");
        if (!result.success) {
          console.debug("Global search shortcut failed", {
            command: "focus-global-search",
            namespace: ns,
            error: result.error
          });
        }
      }
    };
    $[1] = ns;
    $[2] = sendShortcutCommand;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useRegisterHotkey(t1);
  return null;
}
function EmbeddedApplicationHotkeys() {
  const $ = _c(2);
  const {
    isReady
  } = useBidc();
  let t0;
  if ($[0] !== isReady) {
    t0 = isReady ? <GlobalSearchHotkey /> : null;
    $[0] = isReady;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function AppBidcProvider(t0) {
  const $ = _c(6);
  const {
    children,
    pathname
  } = t0;
  let t1;
  if ($[0] !== pathname) {
    t1 = getPageNamespace(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const namespace = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <EmbeddedApplicationHotkeys />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== namespace) {
    t3 = <BidcProvider ns={namespace}>{t2}{children}</BidcProvider>;
    $[3] = children;
    $[4] = namespace;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}